export const SIGNUP_URL = '/member/signup/select_type'
export const NOTICE_AND_ACTION_FORM = '/help/notice_and_action_form'
